module.exports = __webpack_public_path__ + "img/logo.722dbca2.png";